import { Field, FieldProps } from "formik";
import * as React from "react";
import { Alert } from "react-bootstrap";
import { FFieldInputI } from "../../types";

export const FFieldTextarea: React.FC<FFieldInputI> = (props) => {
    const {
        formName,
        label,
        required,
        onBlur,
        onChange,
        tabIndex,
        autoFocus,
        id,
        labelAppend,
        className,
    } = props;

    return (
        <Field name={formName}>
            {({
                field, // { name, value, onChange, onBlur }
                form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                meta,
            }: FieldProps) => (
                <div className={`form-floating ${className}`}>
                    <textarea
                        id={id ?? `f_${formName}`}
                        className={"form-control"}
                        name={field.name}
                        value={field.value}
                        placeholder={label?.toString()}
                        onChange={(e) => {
                            form.handleChange(formName)(e);

                            if (onChange) {
                                onChange(e.currentTarget.value);
                            }
                        }}
                        onBlur={(e) => {
                            form.handleBlur(formName)(e);
                            if (onBlur) {
                                onBlur(field.value);
                            }
                        }}
                        tabIndex={tabIndex}
                        autoFocus={autoFocus}
                        // {...field}
                    >
                        {field.value}
                    </textarea>

                    <label htmlFor={formName} className={"form-label"}>
                        {required ? <sup>* </sup> : null}
                        {label}
                        {labelAppend === null ? (
                            ""
                        ) : labelAppend ? (
                            <>{labelAppend}</>
                        ) : (
                            ":"
                        )}
                    </label>

                    {meta.touched && meta.error && (
                        <Alert variant={"warning"} className={"mt-2"}>
                            {meta.error}
                        </Alert>
                    )}
                </div>
            )}
        </Field>
    );
};
